import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { authReducer, forgotPassReducer } from "./Reducers/authReducer";
import thunk from "redux-thunk";
import { amenitiesReducer } from "./Reducers/amenitiesReducer";
import { amenitiesResaleReducer } from "./Reducers/amenitiesResaleReducer";
import {
  addAdminReducer,
  adminListReducer,
  adminAccessCodeListReducer,
  editAdminReducer,
  enumsReducer,
  viewAdminReducer,
  addAccessCodeReducer,
  removeAccessCodeReducer,
} from "./Reducers/adminReducer";
import {
  countryReducer,
  stateReducer,
  cityReducer,
} from "./Reducers/settingsReducer";
import { addPlanReducer, SubscriptionReducer, viewPlanReducer } from "./Reducers/subscriptionsReducer";
import { consultantList, addConsultant, viewConsultant, blockUnblockConsultant, acceptDeclineConsultant, consultantProjectsReducer, consultantProjectStatusReducer } from "./Reducers/consultantReducer";
import { unitsReducer } from "./Reducers/unitsReducer";
import { categoryReducer } from "./Reducers/categoryReducer";
import { categoryResaleReducer } from "./Reducers/categoryResaleReducer";
import { collectionReducer } from "./Reducers/collectionsReducer";
import { collectionResaleReducer } from "./Reducers/collectionsResaleReducer";
import {
  addRemovePermissionReducer,
  fetchPermissionReducer,
  removeAclReducer,
  updateAclReducer
} from "./Reducers/permissionReducer";
import { builderReducer } from "./Reducers/builderReducer";
import { builderResaleReducer } from "./Reducers/builderResaleReducer";
import { projectReducer } from "./Reducers/projectReducer";
import { projectResaleReducer } from "./Reducers/projectResaleRedcuer";
import { teamReducer } from "./Reducers/teamReducer";
import { agentReducer } from "./Reducers/agentReducer";
import { resellerReducer } from "./Reducers/resellerReducer";
import { homeVisitReducer } from "./Reducers/homeVisitsReducer";
import { agentProfitRangeReducer } from "./Reducers/agentProfitRangeReducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { subCategoryReducer } from "./Reducers/subCategoryReducer";
import { propertyReducer } from "./Reducers/propertyReducer";
import { propertyResaleReducer } from "./Reducers/propertiesResaleReducer";
import { propertyResaleVibeReducer } from "./Reducers/propertyResaleVibeReducer";
import { couponReducer } from "./Reducers/couponReducer";
import { eventsReducer } from "./Reducers/eventsReducer";
import { meetingReducer } from "./Reducers/meetingReducer";
import { usersReducer } from "./Reducers/usersReducer";
import { bookingReducer } from "./Reducers/bookingReducer";
import { blogReducer } from "./Reducers/blogReducer";
import { emailReducer } from "./Reducers/emailAddReducer";
import { loaderReducer } from "./Reducers/loaderReducer";
import { planReducer } from "./Reducers/planReducer";
import { adsBannersReducer } from "./Reducers/adsBannersReducer";
import { chatReducer } from "./Reducers/chatReducer";
import { cancellationPolicies } from "./Reducers/cancellationPoliciesReducer";
import { dealsReducer } from "./Reducers/dealsReducer";
import { referralReducer } from "./Reducers/referralReducer";
import { rewardsReducer } from "./Reducers/rewardsReducer";
import { franchiseReducer } from "./Reducers/franchiseReducer";
import { financePartnersReducer } from "./Reducers/financePartnersReducer";
import { referralCommissionReducer } from "./Reducers/referralCommissionReducer";
import { paymentReducer } from "./Reducers/paymentsReducer";
import { WalletReducer } from "./Reducers/walletRefundReducer";
import { newsReducer } from "./Reducers/newsReducer";
import { newsBrandReducer } from "./Reducers/newsBrandReducer";
import { pageReducer } from "./Reducers/pagesReducer";
import { brandReducer } from "./Reducers/brandsReducer";
import { projectReportReducer } from "./Reducers/projectReportReducer";
import { brandsLeasingReducer } from "./Reducers/brandsLeasingReducer";
import { dashboardReducer } from "./Reducers/dashboardReducer";
import { invitesReducer } from "./Reducers/invitesReducer";
import { enquiryReducer } from "./Reducers/enquiryReducer";
import { cabRequestReducer } from "./Reducers/cabRequestReducer";
import { countryStateReducer } from "./Reducers/countryReducer";
import { notificationReducer } from "./Reducers/notificationReducer";
import { emailTemplatesReducer } from "./Reducers/emailReducer";
// import { changePassword } from "./Actions/passwordChangeAction";
import { currencyReducer } from "./Reducers/currencyReducer";
import { changePasswordReducer } from "./Reducers/changePasswordReducer";
import { faqReducer } from "./Reducers/faqReducer";
import { reviewRatingReducer } from "./Reducers/ratingReviewPanelReducer";
import { siteVisitReducer } from "./Reducers/siteVisitReducer";
import { localityReducer } from "./Reducers/localityReducer";
import { rankingReducer } from "./Reducers/rankingReducer";
import { rankingResaleReducer } from "./Reducers/resaleRankingReducer";
import { homeBannerReducer } from "./Reducers/homeBannerReducer";
import { vrHomeVrReducer } from "./Reducers/homeVrReducer";
import { homeCategoryReducer } from "./Reducers/homeCategoryReducer";
import { ooraPlanReducer } from "./Reducers/ooraReducer";
import { contactUsReducer } from "./Reducers/contactUsReducer";
import { reelRankingReducer } from "./Reducers/reelRankingReducer";
import { rentalPlanReducer } from "./Reducers/rentalPlanReducer";
import { vrShootRentalPlanReducer } from "./Reducers/rentalPlanReducer";
import { leadReducer } from "./Reducers/leadReducer";
import { vrShootRequestReducer } from "./Reducers/vrShootRequestReducer";
import { agentMarginDetailsReducer } from "./Reducers/agentMarginDetailsReducer";
import { rewardCouponReducer } from "./Reducers/rewardCouponReducer";
import { featuredBusinessPropertyReducer } from "./Reducers/featuredBusinessPropertyReducer";
import { SurroundingIndustriesReducer } from "./Reducers/surroundingIndutriesReducer";
import { commingSoonCitiesReducer } from "./Reducers/comingSoonCitiesReducer";
import { appointmentConfigReducer } from "./Reducers/appointmentConfigReducer";
import { experienceCenterReducer } from "./Reducers/experienceCenterReducer";
import { propertyRentalReducer } from "./Reducers/rentalPropertiesReducer";
import { rentalBookingReducer } from "./Reducers/rentalBookingReducer";
import { corporateRentalDiscountReducer } from "./Reducers/corporateRentalDiscountReducer";
import { userQueryProjectReducer } from "./Reducers/userQueryProjectReducer";
import { userViewVrHistoryReducer } from "./Reducers/userViewVrHistoryReducer";
import { Currency } from "lucide-react";

// let user = localStorage.getItem("userInfo")
//   ? JSON.parse(localStorage.getItem("userInfo"))
//   : null;

// let initialState = {
//   admin: {
//     isAuthenticated: user ? true : false,
//     loading: user ? false : null,
//     lastFetched: null,
//     admin: user,
//   },
// };

let initialState = {};

const composeEnhancers =
  typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const reducer = combineReducers({
  // Add your reducers herec
  country: countryStateReducer,
  subscription: SubscriptionReducer,
  subscriptionAdd: addPlanReducer,
  subscriptionView: viewPlanReducer,
  consultantList: consultantList,
  propertyRental: propertyRentalReducer,
  consultantAdd: addConsultant,
  consultantAcceptDecline: acceptDeclineConsultant,
  consultantBlockUnblock: blockUnblockConsultant,
  consultantView: viewConsultant,
  consultantProjects: consultantProjectsReducer,
  consultantProjectStatus: consultantProjectStatusReducer,
  cancellationPolicies: cancellationPolicies,
  admin: authReducer,
  plan: planReducer,
  forgotPass: forgotPassReducer,
  adminList: adminListReducer,
  addAdmin: addAdminReducer,
  addAccessCode: addAccessCodeReducer,
  removeAccessCode: removeAccessCodeReducer,
  editAdmin: editAdminReducer,
  viewAdmin: viewAdminReducer,
  commingSoonCities: commingSoonCitiesReducer,
  accessList: adminAccessCodeListReducer,
  country: countryReducer,
  states: stateReducer,
  city: cityReducer,
  vrShootRequest: vrShootRequestReducer,
  oora: ooraPlanReducer,
  experienceCenter: experienceCenterReducer,
  rentalPlan: rentalPlanReducer,
  vrShootRentalPlan: vrShootRentalPlanReducer,
  locality: localityReducer,
  homeBanner: homeBannerReducer,
  homeCategory: homeCategoryReducer,
  ranking: rankingReducer,
  rankingResale: rankingResaleReducer,
  appointmentConfig: appointmentConfigReducer,
  ratingReviewPanel: reviewRatingReducer,
  emailAdd: emailReducer,
  leads: leadReducer,
  contactUs: contactUsReducer,
  currency: currencyReducer,
  categories: categoryReducer,
  categoriesResale: categoryResaleReducer,
  units: unitsReducer,
  amenities: amenitiesReducer,
  amenitiesResale: amenitiesResaleReducer,
  enumsData: enumsReducer,
  reels: reelRankingReducer,
  collections: collectionReducer,
  collectionsResale: collectionResaleReducer,
  permissions: addRemovePermissionReducer,
  permissionList: fetchPermissionReducer,
  updateAcl: updateAclReducer,
  removeAcl: removeAclReducer,
  builders: builderReducer,
  buildersResale: builderResaleReducer,
  projects: projectReducer,
  projectResale: projectResaleReducer,
  propertiesResale: propertyResaleReducer,
  teamMembers: teamReducer,
  agents: agentReducer,
  reseller: resellerReducer,
  homeVisit: homeVisitReducer,
  agentProfitRange: agentProfitRangeReducer,
  subCategories: subCategoryReducer,
  properties: propertyReducer,
  propertyResaleVibe: propertyResaleVibeReducer,
  pages: pageReducer,
  coupons: couponReducer,
  events: eventsReducer,
  meetings: meetingReducer,
  users: usersReducer,
  vrHome: vrHomeVrReducer,
  bookings: bookingReducer,
  blog: blogReducer,
  rewardCoupon: rewardCouponReducer,
  loader: loaderReducer,
  adsBanners: adsBannersReducer,
  chats: chatReducer,
  deals: dealsReducer,
  referrals: referralReducer,
  rewards: rewardsReducer,
  franchises: franchiseReducer,
  finance_partners: financePartnersReducer,
  referral_commission: referralCommissionReducer,
  payments: paymentReducer,
  refunds: WalletReducer,
  agentMarginDetails: agentMarginDetailsReducer,
  news: newsReducer,
  newsBrand: newsBrandReducer,
  brands: brandReducer,
  projectReport: projectReportReducer,
  brandsLeasing: brandsLeasingReducer,
  surroundingIndustries: SurroundingIndustriesReducer,
  dashboard: dashboardReducer,
  invites: invitesReducer,
  enquiries: enquiryReducer,
  featuredBusinessProperty: featuredBusinessPropertyReducer,
  cabs: cabRequestReducer,
  notification: notificationReducer,
  emailTemplates: emailTemplatesReducer,
  changePassword: changePasswordReducer,
  faq: faqReducer,
  siteVisit: siteVisitReducer,
  rentalBooking: rentalBookingReducer,
  corporateRentalDiscount: corporateRentalDiscountReducer,
  userQueryProject: userQueryProjectReducer,
  userViewVrHistory: userViewVrHistoryReducer
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["admin"],
};

const persistedReducer = persistReducer(persistConfig, reducer);

const middleware = [thunk];

// Create the Store
const store = createStore(
  // reducer,
  persistedReducer,
  initialState,
  // composeWithDevTools(applyMiddleware(...middleware))
  composeEnhancers(applyMiddleware(...middleware))
);
export const persistor = persistStore(store);
export default store;
